import { render } from "./DataSourceDetail.vue?vue&type=template&id=bcc73352&scoped=true&ts=true"
import script from "./DataSourceDetail.vue?vue&type=script&lang=ts"
export * from "./DataSourceDetail.vue?vue&type=script&lang=ts"

import "./DataSourceDetail.vue?vue&type=style&index=0&id=bcc73352&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc73352"]])

export default __exports__